export interface MenuItem {
    label: string;
    keybinding?: string;
    /** Why the item cannot be chosen now; the item is shown disabled with this as its tooltip. */
    disabled?: string;
    run: () => void;
}

/** Closes the menu that is open, if any. */
let closeOpen: (() => void) | undefined;

/** A menu at the pointer, or at a point under a button; `null` entries are separators. */
export function showMenu(at: Pick<MouseEvent, "clientX" | "clientY">, items: (MenuItem | null)[]): void {
    closeOpen?.();
    const menu = document.createElement("div");
    menu.className = "wb-menu";
    menu.setAttribute("role", "menu");
    for (const item of items) {
        if (item === null) {
            const separator = document.createElement("div");
            separator.className = "wb-menu-separator";
            menu.append(separator);
            continue;
        }
        const row = document.createElement("button");
        row.type = "button";
        row.className = "wb-menu-item";
        row.setAttribute("role", "menuitem");
        if (item.disabled !== undefined) {
            row.disabled = true;
            row.title = item.disabled;
        }
        const label = document.createElement("span");
        label.textContent = item.label;
        row.append(label);
        if (item.keybinding !== undefined) {
            const key = document.createElement("kbd");
            key.textContent = item.keybinding;
            row.append(key);
        }
        row.addEventListener("click", () => {
            close();
            item.run();
        });
        menu.append(row);
    }
    document.body.append(menu);
    const { innerWidth, innerHeight } = window;
    const rect = menu.getBoundingClientRect();
    menu.style.left = `${Math.min(at.clientX, innerWidth - rect.width - 4)}px`;
    menu.style.top = `${Math.min(at.clientY, innerHeight - rect.height - 4)}px`;
    const close = () => {
        closeOpen = undefined;
        menu.remove();
        window.removeEventListener("pointerdown", outside, true);
        window.removeEventListener("keydown", escape, true);
    };
    const outside = (e: Event) => {
        if (!menu.contains(e.target as Node)) close();
    };
    const escape = (e: KeyboardEvent) => {
        if (e.key === "Escape") close();
    };
    window.addEventListener("pointerdown", outside, true);
    window.addEventListener("keydown", escape, true);
    closeOpen = close;
    menu.querySelector<HTMLElement>(".wb-menu-item:enabled")?.focus();
}
